import React, { FC, useCallback } from "react";
import TransparentPage from "../common/navigation/PageTransparent";
import { useNavigate } from "react-router-dom";
import { InventoryGeometryItem } from "../../hooks/database/types/inventories";
import Spinner from "../common/F7/Spinner";
import { useUpdateObject } from "../../hooks/database/useUpdateObject";
import { useCurrentObject } from "../../hooks/database/useCurrentObject";
import ModifyGeometry from "./components/ModifyGeometry";
import ModifyPoint from "./components/ModifyPoint";

const ObjectModifyPage: FC = () => {
  const navigate = useNavigate();

  const { data: object } = useCurrentObject();
  const { execute: updateObject } = useUpdateObject();

  const handleConfirmClick = useCallback(
    async (geom: InventoryGeometryItem["geom"]) => {
      if (!object) {
        return;
      }
      await updateObject({
        ...object,
        geom: {
          ...object.geom,
          geometry: geom.geometry,
        },
      });
      navigate("../");
    },
    [navigate, object, updateObject]
  );

  const handleCancelClick = useCallback(() => {
    navigate("../");
  }, [navigate]);

  if (!object) {
    return <Spinner />;
  }

  return (
    <TransparentPage>
      {object.geom.geometry.type === "Point" ? (
        <ModifyPoint onCancel={handleCancelClick} onSave={handleConfirmClick} coordinate={object.geom.geometry.coordinates} />
      ) : (
        <ModifyGeometry
          onSave={handleConfirmClick}
          onCancel={handleCancelClick}
          geomType={object.geom.geometry.type}
          coordinates={object.geom.geometry.type === "LineString" ? object.geom.geometry.coordinates : object.geom.geometry.coordinates[0]}
        />
      )}
    </TransparentPage>
  );
};

export default ObjectModifyPage;
